import { render, staticRenderFns } from "./ProfileEditTabCompliance.vue?vue&type=template&id=29ae7684&scoped=true&"
import script from "./ProfileEditTabCompliance.vue?vue&type=script&lang=js&"
export * from "./ProfileEditTabCompliance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ae7684",
  null
  
)

export default component.exports